'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SocialRow = undefined;

var _SocialRow2 = require('./SocialRow');

var _SocialRow3 = _interopRequireDefault(_SocialRow2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.SocialRow = _SocialRow3.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/SocialRow/index.js
// module id = 1774
// module chunks = 0